import { Fields } from '@measured/puck';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ColorPicker from './ColorPicker';

export type ColorSubProps = {
  backgroundColor: string;
  hoverColor: string;
};
export type ColorProps = {
  color: ColorSubProps;
};

export const colorField: Fields<ColorProps> = {
  color: {
    type: 'custom',
    label: 'Color',
    render: ({ value, onChange }) => {
      const [isOpen, setIsOpen] = useState(false);

      const toggleAccordion = () => {
        setIsOpen(!isOpen);
      };

      const handleColorChange = (colorKey: string, color: string) => {
        onChange({
          ...value,
          [colorKey]: color,
        });
      };

      return (
        <div>
          <div
            className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
            onClick={toggleAccordion}>
            <h3>Customize Colors</h3>
            {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
          </div>
          {isOpen && (
            <div className="flex flex-col gap-4 w-full items-center border border-gray-300 rounded p-2 pb-4">
              <ColorPicker
                value={value.backgroundColor}
                onChange={color => handleColorChange('backgroundColor', color)}
                label={'Background Color'}
                tooltip={'backgroundColor'}
              />
              <ColorPicker
                value={value.hoverColor}
                onChange={color => handleColorChange('hoverColor', color)}
                label={'Hover Color'}
                tooltip={'hoverColor'}
              />
            </div>
          )}
        </div>
      );
    },
  },
};
